import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BenchmarkPipeline from 'src/components/newRecruiterFlow/benchmarkPipline/benchmarkPipeline';
import HireRemote from 'src/components/newRecruiterFlow/hireRemote/hireRemote';
import UpdatedPlacementDrive from 'src/components/newRecruiterFlow/placementDrive/UpdatedPlacementDrive';

export enum HiringFlowScreen {
	SELECT_HIRING_FLOW = 'SELECT_HIRING_FLOW',
	SELECT_CAMPUS_HIRING_FLOW = 'SELECT_CAMPUS_HIRING_FLOW',
	SELECT_UPCOMING_DRIVES = 'SELECT_UPCOMING_DRIVES',
	SELECT_BENCHMARK_PIPELINE = 'SELECT_BENCHMARK_PIPELINE',
	SELECT_CONNECT_WITH_ATS = 'SELECT_CONNECT_WITH_ATS',
	SELECT_FRESHER_HIRING_FLOW = 'SELECT_FRESHER_HIRING_FLOW',
	SELECT_LATERAL_HIRING_FLOW = 'SELECT_LATERAL_HIRING_FLOW',
}
const DrivePrototype = () => {
	const navigate = useNavigate();

	const [hiringFlowScreen, setHiringFlowScreen] = useState<HiringFlowScreen>(HiringFlowScreen.SELECT_HIRING_FLOW);

	const [searchParams, setSearchParams] = useSearchParams();
	const hiringFlowType = searchParams.get('hiringFlowType');

	useEffect(() => {
		if (hiringFlowType === 'campus') {
			// setHiringFlowScreen(HiringFlowScreen.SELECT_CAMPUS_HIRING_FLOW);
		} else if (hiringFlowType === 'fresher') {
			navigate('/fresher-candidates');
		} else if (hiringFlowType === 'lateral') {
			navigate(`/experience-candidates`);
		} else if (hiringFlowType === 'upcoming-drives') {
			setHiringFlowScreen(HiringFlowScreen.SELECT_UPCOMING_DRIVES);
		} else if (hiringFlowType === 'benchmark') {
			// setHiringFlowScreen(HiringFlowScreen.SELECT_BENCHMARK_PIPELINE);
			navigate('/recruiter-dashboard/hiring-assessment-list');
		} else if (hiringFlowType === 'connect-with-ATS') {
			// setHiringFlowScreen(HiringFlowScreen.SELECT_CONNECT_WITH_ATS);
			navigate('/create-new-hiring/freshers-hiring/lateral-hiring');
		} else {
			setHiringFlowScreen(HiringFlowScreen.SELECT_HIRING_FLOW);
		}
	}, [hiringFlowType]);

	return (
		<div className="relative isolate">
			{/* background  */}
			<div className="absolute w-full h-full z-[-1] opacity-45 bg-[radial-gradient(57.43%_52.47%_at_68.62%_53.08%,rgba(72,150,255,0.17)_13.5%,rgba(255,255,255,0)_70%),radial-gradient(163.85%_91.48%_at_20.22%_27.62%,rgba(36,203,201,0.17)_8.25%,rgba(255,255,255,0)_59.33%)] hidden md:block"></div>

			<div className="mt-[30px] md:mt-[80px] tlg:!max-w-[1440px] mx-auto z-[100] ">
				<div className="w-80 md:!w-8/12 flex justify-center items-center mx-auto ">
					<h1 className="text-[#28293D] text-center font-inter text-[24px] md:text-[32px] font-[700] leading-[40px]">
						What brings you to LevelUp?
					</h1>
				</div>
				{/* placement */}

				<div className="max-w-full tlg:max-w-[1440px] mx-auto txl:px-40">
					<UpdatedPlacementDrive />
					<hr className="md:mt-[25px] hidden md:block" />
					<HireRemote setHiringFlowScreen={setHiringFlowScreen} />
					<hr className="md:mt-[25px] hidden md:block" />
					<BenchmarkPipeline setHiringFlowScreen={setHiringFlowScreen} />
					<hr className="md:mt-[25px] hidden md:block" />
				</div>
			</div>
		</div>
	);
};

export default DrivePrototype;
